import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ConfigService, ResetInformationService } from '../../services';
import { FacilityLocationsFormGroupType } from '../facility-locations/models/location-form';
import { AWBSearchFormGroupType } from './awb-search/models/awb-search-form';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false,
})
export class SearchComponent implements OnInit {
    public enableSearchByFlightNumber: boolean;
    public searchByAwb = true;
    public isSearching = false;

    @Output() eventOnEnter = new EventEmitter<AWBSearchFormGroupType>();
    @Output() eventOnChangeLocation = new EventEmitter<FacilityLocationsFormGroupType>();

    constructor(
        private configService: ConfigService,
        private resetInformationService: ResetInformationService
    ) {}

    ngOnInit(): void {
        this.setSearchByFlightNumber();
    }

    setSearchByFlightNumber(): void {
        this.enableSearchByFlightNumber = this.configService.isSearchByFlightNumberEnable();
    }

    changeBySearch(): void {
        if (this.isSearching) {
            return;
        }

        this.searchByAwb = !this.searchByAwb;
    }

    resetInformation(): void {
        this.resetInformationService.resetUserInformation(true);
    }

    onChangeLocation($event: FacilityLocationsFormGroupType): void {
        this.eventOnChangeLocation.emit($event);
    }

    onEnter($event: AWBSearchFormGroupType): void {
        this.resetInformation();
        this.eventOnEnter.emit($event);
    }

    isSearchingValue(searching: boolean): void {
        this.isSearching = searching;
    }
}
